import { render } from "./index.vue?vue&type=template&id=c6b03804"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c6b03804&lang=css"

import exportComponent from "E:\\sunjibo\\upstream_space\\code\\shenzhou\\medical-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__